'use client';

import { TTEventMapped } from '@/@types'; // Adjust path to your types
import { PaginatedList } from "@/components/ui/list/PaginatedList";
import { cn, handleScrollToId } from '@/lib/utils';
import { Fish, MailCheck } from "lucide-react";
import { useState } from 'react';
import EventCard from './EventCard';

interface EventsListProps {
    events: TTEventMapped[];
}

export default function EventsList({events}: EventsListProps) {
    const [activeTab, setActiveTab] = useState('upcoming');

    const handleMailingListClick = () => handleScrollToId('connect');

    // Current time as Unix timestamp
    const currentTime = Date.now() / 1000;


    // Computed equivalents
    const upcomingEvents = events.filter((event) => (event.status !== 'draft' && event.end.unix >= currentTime)).sort((a, b) => a.start.unix - b.start.unix);
    const pastEvents = events.filter((event) => (event.status !== 'draft' && event.end.unix < currentTime) );

    return (
        <div className="flex flex-wrap sm:-m-4 -mx-4 -mb-10 -mt-4" id="events-list">
            <div className="w-full">
                {events.length === 0 && (
                    <div className="text-center">
                        <h2 className="text-2xl">No events available at this time...</h2>
                    </div>
                )}
                {events.length > 0 && (
                    <div>
                        <div className="flex flex-wrap justify-center py-4">
                            <div className="flex space-x-4 text-sm">
                                <button
                                    className={cn(
                                        'px-4 py-2 font-medium rounded-t-lg focus:outline-none',
                                        activeTab === 'upcoming'
                                            ? 'border-b-2 border-primary text-primary'
                                            : 'text-muted-foreground hover:text-primary'
                                    )}
                                    onClick={() => setActiveTab('upcoming')}
                                >
                                    Upcoming Events
                                </button>
                                <button
                                    className={cn(
                                        'px-4 py-2 font-medium rounded-t-lg focus:outline-none',
                                        activeTab === 'past'
                                            ? 'border-b-2 border-primary text-primary'
                                            : 'text-muted-foreground hover:text-primary'
                                    )}
                                    onClick={() => setActiveTab('past')}
                                >
                                    Past Events
                                </button>
                            </div>

                            <div className="w-full mt-4">
                                {activeTab === 'upcoming' && (
                                    <div className="flex flex-wrap justify-center">
                                        {upcomingEvents.length === 0 ? (
                                            <div className="text-center">
                                                {/* TODO: pull this content from a CMS */}
                                                <h2 className="text-3xl font-extrabold">
                                                  {false && (
                                                    <>
                                                    <Fish  className={"mx-2 text-primary text-4xl inline-flex"}/>
                                                    {" "}
                                                    </>
                                                  )}
                                                    More Laughs are on the Way!

                                                </h2>
                                                <h3 className="py-2">
                                                    Be the first to know when we announce the next event.
                                                </h3>
                                                <h3
                                                    className="m-0 py-3 text-xl text-center cursor-pointer"
                                                    role="button"
                                                    tabIndex={0}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') handleMailingListClick();
                                                    }}
                                                    onClick={handleMailingListClick}
                                                >

                                                  <MailCheck  className={"mx-2 text-primary text-2xl inline-flex"}/>
                                                    Subscribe for <strong className="text-primary">email
                                                    updates</strong> !
                                                </h3>

                                            </div>
                                        ) : (
                                            <PaginatedList
                                                items={upcomingEvents}
                                                itemsPerPage={4}
                                                wrapperClassName="flex flex-wrap justify-center"
                                                renderItem={(event) => (
                                                    <div
                                                        key={event.id}
                                                        className={cn(
                                                            'p-4 sm:mb-0 mb-6 space-y-3 text-center',
                                                            upcomingEvents.length > 1 ? 'md:w-1/2' : ''
                                                        )}
                                                    >
                                                        <EventCard item={event} isPast={false}/>
                                                    </div>
                                                )}
                                            />
                                        )}
                                    </div>
                                )}
                                {activeTab === 'past' && (

                                    <PaginatedList
                                        items={pastEvents}
                                        itemsPerPage={4}
                                        wrapperClassName="flex flex-wrap justify-center"
                                        renderItem={(event) => (
                                            <div
                                                key={event.id}
                                                className={cn(
                                                    'p-4 sm:mb-0 mb-6 space-y-3 text-center',
                                                    pastEvents.length > 1 ? 'md:w-1/2' : ''
                                                )}
                                            >
                                                <EventCard item={event} isPast/>
                                            </div>
                                        )}
                                    />


                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
